import React from 'react';

const Card = ({ children, className = '', hover = false, testimonial = false, ...props }) => {
  const base = testimonial ? 'ofs-card-testimonial' : 'ofs-card';
  return (
    <div className={`${base} ${className}`} {...props}>
      {children}
    </div>
  );
};

export default Card;
